import ModuleView from "@/components/shieldx/ModuleView";
import { ShieldCheck } from "lucide-react";
export default function PlatformSecurity() {
  return <ModuleView name="platform-security" icon={ShieldCheck} />;
}
